import activityLogLocale from 'modules/activityLog/ActivityLog/localization/en.json'
import aproLogDetailsDetailsLocale from 'modules/activityLog/details/AproLogDetails/localization/en.json'
import certificateLogDetailsLocale from 'modules/activityLog/details/CertificateLogDetails/localization/en.json'
import cesTestLogDetailsLocale from 'modules/activityLog/details/CesTestLogDetails/localization/en.json'
import courseLogDetailsLocale from 'modules/activityLog/details/CourseLogDetails/localization/en.json'
import cstLogDetailsLocale from 'modules/activityLog/details/CstLogDetails/localization/en.json'
import educationLogDetailsLocale from 'modules/activityLog/details/EducationLogDetails/localization/en.json'
import elearningLogDetailsLocale from 'modules/activityLog/details/ElearningLogDetails/localization/en.json'
import onboardAssessmentLogDetailsLocale from 'modules/activityLog/details/OnboardAssessmentLogDetails/localization/en.json'
import pproLogDetailsLocale from 'modules/activityLog/details/PproLogDetails/localization/en.json'
import rapidElearningLogDetailsLocale from 'modules/activityLog/details/RapidElearningLogDetails/localization/en.json'

const en = {
  activityLog: activityLogLocale,
  aproLogDetails: aproLogDetailsDetailsLocale,
  certificateLogDetails: certificateLogDetailsLocale,
  cesTestLogDetails: cesTestLogDetailsLocale,
  courseLogDetails: courseLogDetailsLocale,
  cstLogDetails: cstLogDetailsLocale,
  educationLogDetails: educationLogDetailsLocale,
  elearningLogDetails: elearningLogDetailsLocale,
  onboardAssessmentLogDetails: onboardAssessmentLogDetailsLocale,
  pproLogDetails: pproLogDetailsLocale,
  rapidElearningLogDetails: rapidElearningLogDetailsLocale,
}

export default en
